import React from 'react'

export default function ReitekinaHouseki() {
	return (
		<>-- Reiteki na Houseki --</>
	);
}